import React from 'react'

export class GooglePolyline extends React.PureComponent {
  componentDidMount () {
    const {mapInstance, positions, color, weight} = this.props
    this._polyline = new window.google.maps.Polyline({
      path: positions,
      // if mapInstance isn't a rwgps.Map, assume it's a direct reference to the gmap
      map: mapInstance.gmap || mapInstance,
      strokeColor: color,
      strokeWeight: weight
    })
  }

  componentDidUpdate () {
    const {positions, color, weight} = this.props
    this._polyline.setOptions({
      path: positions,
      strokeColor: color,
      strokeWeight: weight
    })
  }

  componentWillUnmount () {
    this._polyline.setMap(null)
    delete this._polyline
  }

  render () {
    return (
      null
    )
  }
}
